import React,{useState,useEffect} from 'react';
import {SectionTitle} from 'components/items';
import makeTitle from 'function/makeTitle.js';
import firebase from 'library/firebase-config.js';
import 'firebase/firestore';
var db = firebase.firestore();

const COLLECTION = "about";
const DOC = "video";

const sectionTitle = [
  {
    text: "BRAND",
    color: "defualt",
    break: false
  },{
    text: "STORY",
    color: "main",
    break: true
  }
]


const BrandStory = () => {
  const [video, setVideo] = useState('');
  const _get = () => {
    db.collection(COLLECTION).doc(DOC).get().then((querySnapshot) => {
      setVideo(querySnapshot.data().value);
    });
  }

  useEffect(() => {
    _get()
  },[])

  return (
    <section className = "BrandStory">
      <div className="section-header">
        <div className="con">
          <SectionTitle text = {makeTitle(sectionTitle)}  type = "center"/>
        </div>
      </div>
      <div className="section-contents">
        <div className="con">
          <div className="wrap-video">
            <div className="video-container">
              <iframe
                className ="iframe-youtube"
                src={video}
                frameBorder="0" 
                width = "100%"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
                title = "about video"
              >

              </iframe>
          </div>
          </div>
          <div className="brand-text">
            <p>2014년 세상에 변화를 만드는 사람이 되고 싶은 대학생 4명이 모여 발달장애인과 농사를 지으며, 발달장애인이 도시농부가 되기를 바라는 마음으로 
            마을 어귀의 작은 텃밭이라는 뜻의 ‘동구밭’은 시작 되었습니다. 22개의 텃밭을 운영할만큼 많은 발달장애인과 비장애인이 참가하면서 의미있는 
            큰 변화를 볼 수 있었습니다.</p>
            <p className="color-sub">“순호씨는 살다보면 우리 아이를 곧 잊겠지만 우리 아이는 순호씨를 평생 기억할거예요. 평생동안 친구가 한 명 있는데 그 친구를 어떻게 잊겠어요?” 라고 말씀해주신 한 발달장애인 참가자 어머님의 말씀처럼 그들의 친구가 되어 발달장애인이 성장하는 모습을 볼 수 있었습니다.</p>
            <p>하지만 동구밭은 여기서 안주하지 않았습니다. 성인 발달장애인들의 가장 큰 문제인 자립에 관심을 갖고, 2016년 가을 텃밭에서 수확한 기쁨을 제품에 
            담아 ‘가꿈비누’라는 이름의 천연비누를 만들었습니다. 그리고 2017년 1월 비누를 직접 만들 수 있는 ‘동구밭 팩토리’를 오픈해 처음 강동텃밭에서 
            만난 친구가 동구밭의 첫 직원이 된 이후 하나 둘 사람들이 모여 지금 ‘동구밭 팩토리’에는 무려 20명의 발달장애인이 함께 일하고 있습니다. </p>
            <p>이제 동구밭은 성인 발달장애인의 자립 문제를 해결하며, 지속가능한 사업을 영위하기 위한 소셜벤처로 거듭나 좋은 제품으로 고객에게는 
            기쁨을 발달장애인에게는 자립을 주는 기업으로 나아갈 것입니다.</p>

          </div>
          
        </div>
      </div>
    </section>
  );
}

export default BrandStory;